
export default function zenkaku2Hankaku (strVal: string): string{
    let halfVal:string = strVal.replace(/[！-～]/g, (tmpStr: string): any =>{
      return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
    });
    halfVal.replace(/”/g, '"').
            replace(/’/g, '\'').
            replace(/‘/g, '`').
            replace(/￥/g, '\\').
            replace(RegExp('　', 'g'), ' ').
            replace(/〜/g, '~');
    return halfVal;
}
